import { Component, OnInit } from '@angular/core';
import { ConfigService } from '../../services/config.service';

@Component({
    selector: 'app-config',
    templateUrl: './config.component.html',
    styleUrls: ['./config.component.css']
})
export class ConfigComponent implements OnInit {
    public configs = [];

    constructor(protected configService: ConfigService) {
        this.load();
    }

    ngOnInit() {
    }

    protected load() {
        this.configService.index().subscribe(configs => {
            this.configs = configs;
        });
    }

    public delete(config) {
        this.configService.destroy(config).subscribe(() => this.load());
    }
}



// WEBPACK FOOTER //
// /Users/dade/work/sportclubby/sportclubby.livestreaming.frontend/src/app/components/config/config.component.ts